// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IjN3","newExpiryDate":"styles_newExpiryDate__14PbV","footer":"styles_footer__2rIXN"};